import { domToPng } from "modern-screenshot";

const MAX_THUMB_WIDTH = 800;

const cropAndDownscale = (sourceDataUrl, bbox, scale) =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      const scaledBbox = {
        x: bbox.x * scale,
        y: bbox.y * scale,
        w: bbox.w * scale,
        h: bbox.h * scale,
      };
      const targetWidth = Math.min(scaledBbox.w, MAX_THUMB_WIDTH * scale);
      const targetScale = targetWidth / scaledBbox.w;
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(scaledBbox.w * targetScale);
      canvas.height = Math.round(scaledBbox.h * targetScale);
      const ctx = canvas.getContext("2d");
      ctx.drawImage(
        image,
        scaledBbox.x,
        scaledBbox.y,
        scaledBbox.w,
        scaledBbox.h,
        0,
        0,
        canvas.width,
        canvas.height,
      );
      resolve(canvas.toDataURL("image/png"));
    };
    image.onerror = (err) => reject(err);
    image.src = sourceDataUrl;
  });

const captureSnippet = async ({ node, bbox }) => {
  if (!node) {
    throw new Error("captureSnippet: node is required");
  }
  const scale = window.devicePixelRatio || 1;
  const fullDataUrl = await domToPng(node, {
    scale,
    filter: (target) =>
      !target?.dataset || target.dataset.snipExclude !== "true",
  });
  return cropAndDownscale(fullDataUrl, bbox, scale);
};

export { captureSnippet };
